import cn from 'classnames'

import type { TAttentionStatusSeverity } from 'partner360/entities/attentionStatuses'

import finishedRobot from '../../../../assets/robot/robot-checklist-badge.png'
import unfinishedRobot from '../../../../assets/robot/robot-checklist-warning.png'
import standardRobot from '../../../../assets/robot/robot-exclamation-badge.png'
import emptyRobot from '../../../../assets/robot/robot-mascot.png'
import highRobot from '../../../../assets/robot/robot-warning-sign-friendly.png'
import topRobot from '../../../../assets/robot/robot-warning-sign.png'

import styles from './AttentionRobotFigure.module.scss'

/** The sign each robot holds is painted in its level's colour: red, orange, yellow. */
const SEVERITY_ROBOTS: Record<number, string> = {
  3: topRobot,
  2: highRobot,
  1: standardRobot,
}

/** With nothing raised the robot holds the plan instead, ticked or half done; with nothing to show
 *  at all it holds nothing. */
const CALM_ROBOTS = {
  finished: finishedRobot,
  unfinished: unfinishedRobot,
  empty: emptyRobot,
}

export type TAttentionCalmRobotState = keyof typeof CALM_ROBOTS

interface IAttentionRobotFigureProps {
  /** The worst level on screen: it picks the robot. */
  severity: TAttentionStatusSeverity
}

/** The tile's figure: the robot of the worst level. Decoration; the words beside it count. */
export const AttentionRobotFigure = ({ severity }: IAttentionRobotFigureProps) => (
  <img
    className={cn(styles.robot, styles.robotWithSign)}
    src={SEVERITY_ROBOTS[severity] ?? standardRobot}
    alt=""
  />
)

AttentionRobotFigure.displayName = 'AttentionRobotFigure'

interface IAttentionCalmRobotProps {
  state: TAttentionCalmRobotState
}

/** The same figure where nothing is raised: what the robot holds says how the plan stands. */
export const AttentionCalmRobot = ({ state }: IAttentionCalmRobotProps) => (
  <img className={styles.robot} src={CALM_ROBOTS[state]} alt="" />
)

AttentionCalmRobot.displayName = 'AttentionCalmRobot'
